//
//
//

export default {
  name: 'policy-item',
  props: {
    text: {    
      type: String,
      default: '隐私政策'
    },
  },
  data() {
    return {
    }
  },
  methods: {
    openLink() {
      if (this.text == '隐私政策') {
        this.$router.open('https://aakit.cn/s/oVd9PkgZO')
      } else if (this.text == '用户协议') {
        this.$router.open('https://aakit.cn/s/N8EkrXpVA')
      } else if (this.text == '在线客服') {
        // 教师和无身份，都去教师客服
        if (this.$store.getters.has_teacher_role || this.$store.getters.parent_roles == 0) {
          this.$router.open('https://aakit.cn/s/El86mpZJ9')
        } else {
          // v5.0.5修改，家长统一去家长指南
          this.$router.open('https://aakit.cn/s/PVRa9Ad7Q')
        }
      }
    },
  },
  mounted() {

  }
}



// WEBPACK FOOTER //
// ./src/components/el-policy-item.vue